// React Basic and Bootstrap
import React from "react"

//Import Components
import LatestBlogPosts from "./LatestBlogPosts"
// import ReviewsSection from "./ReviewsSection"
import Faq from "./Faq"

const SectionBeforeFooter = () => {
  return (
    <>
      <section className="section bg-light">
        {/* <ReviewsSection /> */}
        <Faq />
        <LatestBlogPosts />
      </section>
    </>
  )
}

export default SectionBeforeFooter
